<script setup>
import { onMounted, ref } from 'vue'

import { useAuthStore } from '@/pinia/auth'
const authStore = useAuthStore()

const isVisible = ref(false)

onMounted(() => {
  setTimeout(() => {
    isVisible.value = true
  }, 300)
})
</script>

<template>
  <modal-window
    v-if="!authStore.isQuotilaBannerHidden && !authStore.isExtruderOrExpress && isVisible"
    :modal_open="true"
    :is-closable="false"
  >
    <div class="text-center text-base max-w-xl mx-auto">
      <div class="w-fit mx-auto">
        <h2 class="text-2xl mb-3"><b>TOUCH</b> is becoming <b>QUOTILA</b></h2>
        <div class="mb-5 w-full h-1 bg-linear-to-r from-[#FDCE0D] via-[#198481] to-[#4265B2]"></div>
      </div>
      <img class="max-w-xs mx-auto mb-5" src="@/assets/images/quotila.svg" alt="Quotila Logo" />
      <p class="mb-5 text-gray-600">
        We've decided to introduce a new, distinctive name that works consistently across global markets
      </p>
      <p class="text-[#21B7B3] font-bold">What does this mean for you?</p>
      <p class="mb-5 font-bold">Nothing will change in your day-to-day use</p>
      <p class="mb-5 text-gray-600">
        All features, payments, login details and performance remain exactly the same. From the end of March, you'll
        start seeing the new name across the software.
      </p>
      <button class="btn bg-[#4265B2] text-white btn-lg" @click="authStore.isQuotilaBannerHidden = true">
        Got it!
      </button>
    </div>
  </modal-window>
</template>
